module.exports = __webpack_public_path__ + "img/3.97d07edc.svg";